import { forwardRef } from 'react'
import { useIntl } from 'react-intl'
import ExperiencePageTrendingDestinations from './ExperiencesPageTrendingDestinations'
import GlobalSearchContainerPane, { GlobalSearchContainerPaneContent } from 'components/Search/GlobalSearch/GlobalSearchContainerPane'
import GlobalSearchHeroContainer from 'components/Search/GlobalSearch/GlobalSearchHeroContainer'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import config from 'constants/config'
import { destinationsMap } from 'constants/experience'
import ExperiencesSearchControls from 'components/Search/Experiences/ExperiencesSearchControls'

const SearchHero = styled(GlobalSearchHeroContainer)`
  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} 0 ${rem(60)} 0;
  }
`

const ExperiencePageSearchHeader = forwardRef<HTMLDivElement>((props, ref) => {
  const intl = useIntl()
  const destinations = destinationsMap(config.BRAND)
  const trendingDestinationsLabels = destinations.map(destination => destination.name)

  return (
    <SearchHero
      ref={ref}
      heroImageId="nz83bzbyhxc8r1b8t8m"
      title={intl.formatMessage({
        id: 'SyDhyLS6DiNLRECyle9W',
        defaultMessage: 'Find the perfect experience in any destination',
        description: 'Hero heading on the experiences landing page search header',
      })}
      aspectRatio="10:3"
    >
      <GlobalSearchContainerPane>
        <GlobalSearchContainerPaneContent>
          <ExperiencesSearchControls />
        </GlobalSearchContainerPaneContent>
      </GlobalSearchContainerPane>
      <GlobalMobileSearchHeroBar
        placeholder={intl.formatMessage({
          id: 'lipSaV1MLwgF5JI-gKI1',
          defaultMessage: 'Search experiences in',
          description: 'Mobile search bar placeholder text on experiences landing page',
        })}
        placeholderTextList={trendingDestinationsLabels}
      />
      <ExperiencePageTrendingDestinations />
    </SearchHero>
  )
})

ExperiencePageSearchHeader.displayName = 'ExperiencePageSearchHeader'

export default ExperiencePageSearchHeader
